"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _react = require("react");

var DealType = _react.PropTypes.instanceOf(_DealRecord.default);

var _default = DealType;
exports.default = _default;
module.exports = exports.default;